import { useCallback, useMemo } from 'react';
import useFilters from './useFilters';

interface Options {
  clearAllOnOriginChange?: boolean;
}

const useSyncFiltersFaresApi = (
  filters: ReturnType<typeof useFilters>,
  options: Options,
  prePopulation: $TSFixMe
) => {
  const { clearAllOnOriginChange = false } = options;
  const onClearAll = filters.onClear;

  const generateLocationsCallbacks = useCallback(
    (location: $TSFixMe) => {
      const handleChange = (locationValue: $TSFixMe) => {
        location.onChange(locationValue);
      };

      const handleClear = () => {
        setTimeout(() => {
          if (clearAllOnOriginChange) {
            onClearAll();
          }
          location.onClear();
        });
      };

      return {
        onClear: handleClear,
        onChange: handleChange
      };
    },
    [clearAllOnOriginChange, onClearAll]
  );

  const extendedFiltersModel = useMemo(() => {
    return {
      locations: {
        ...filters.locations,
        origin: {
          ...filters.locations.origin,
          ...generateLocationsCallbacks(filters.locations.origin)
        },
        destination: {
          ...filters.locations.destination,
          ...generateLocationsCallbacks(filters.locations.destination)
        }
      },
      dateRange: filters.dateRange,
      budget: filters.budget,
      flightType: filters.flightType,
      sorting: filters.sorting,
      flightStopCount: filters.flightStopCount,
      travelClass: filters.travelClass,
      onClear: filters.onClear
    };
  }, [
    filters.budget,
    filters.dateRange,
    filters.flightType,
    filters.locations,
    filters.sorting,
    filters.flightStopCount,
    filters.travelClass,
    generateLocationsCallbacks,
    filters.onClear
  ]);

  /**
   * TODO: This function causes  the issue that a tracking event (change-origin)
   *  is send when a origin is set on prepopulation settings.
   */
  // useEffect(() => {
  //   if (prePopulation && prePopulation.origin && extendedFiltersModel.locations.origin.isSuccess) {
  //     extendedFiltersModel.locations.origin.onChange({ value: prePopulation.origin });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [extendedFiltersModel.locations.origin.isSuccess, prePopulation]);

  return extendedFiltersModel;
};

export default useSyncFiltersFaresApi;
